const BaseConstants = {
  YES: "Y",
  NO: "N",
  TRUE: "Y",
  FALSE: "N"
};
const BooleanToIntegerConstants = {
  TRUE: 1,
  FALSE: 0
};

const UserPreferences = {
  DEFAULT_LANGUAGE: "2"
};
const DocumentStatus = {
  IN_PROGRESS: "IN_PROGRESS",
  RECORDED: "RECORDED",
  VERIFIED: "VERIFIED",
  PUBLISHED: "PUBLISHED",
  ARCHIVED: "ARCHIVED",
  INVALIDATED: "INVALIDATED"
};
const VisibilityLevels = {
  PRIVATE: 1,
  INTERNAL: 2,
  GROUP: 3,
  PUBLIC: 4
};
const GenericCodebookTypes = {
  ATTACHMENT_CONTENT_TYPE: "ATTACHMENT_CONTENT_TYPE",
  LANGUAGE: "LANGUAGE",
  COURT_CASE_TYPE: "COURT_CASE_TYPE",
  DECISION_TYPE: "DECISION_TYPE"
};

const HttpConstants = {
  HTTP_GET_METHOD: "get",
  HTTP_POST_METHOD: "post",
  HTTP_PUT_METHOD: "put",
  HTTP_DELETE_METHOD: "delete",
  JSON_CONTENT_TYPE: "application/json",
  FORM_CONTENT_TYPE: "application/x-www-form-urlencoded",
  MULTIPART_CONTENT_TYPE: "multipart/form-data",
  AUTH_HEADER: "Authorization",
  HTTP_CLIENT_ERROR_CODE: "CLIENT_ERROR",
  HTTP_SERVER_ERROR_CODE: "SERVER_ERROR",
  HTTP_SERVER_ERROR_MESSAGE: "HTTP_ERROR",
  CONTENT_TYPE_HEADER_NAME: "Content-Type",
  SESSION_ID_HEADER: "session-id",
  CSRF_TOKEN_HEADER_NAME: "X-XSRF-TOKEN",
  CSRF_TOKEN_COOKIE_NAME: "XSRF-TOKEN"
};

const RouteTypes = {
  ROOT: "root",
  SINGLETON: "singleton",
  TRANSIENT: "transient",
  REGULAR: "regular"
};

const DocumentTypes = {
  CASE_LAW_DOCUMENT_TYPE: "CASE_LAW_DOCUMENT_TYPE",
  CASE_DECISION_TYPE: "CASE_DECISION_TYPE",
  LEGAL_VIEW_TYPE: "LEGAL_VIEW_TYPE"
};

const Layouts = {
  DEFAULT: "app",
  ROOT: "root",
  APP: "app",
  BASE: "base",
  PORTAL: "portal",
  REGISTRY: "registry"
};

const Topics = {
  DEFAULT: "app"
};

const Errors = {
  ERROR: "Error",
  VERIFICATION_REQUIRED: "verification-required",
  LOGIN_ERROR: "login-error",
  INVALID_CODE: "invalid-code",
  INVALID_TOKEN: "invalid-token",
  FORBIDDEN_STATUS: 403,
  UNAUTHORIZED_STATUS: 401,
  EXPIRED_PASSWORD: 3,
  DB_ERROR_CODE: "db-error"
};

const DateFormats = {
  DATETIME_LOCAL: "DD.MM.YYYY kk:mm:ss",
  DATE: "DD.MM.YYYY",
  SEARCH_DATE: "YYYY-MM-DD",
  DATETIME: "DD.MM.YYYY HH:mm:ss",
  YEAR: "YYYY",
  DAY: "D",
  MONTH: "MMMM"
};

const TimeFormats = {
  LOCAL_TIME: "HH:mm"
};

const EditFormItemTypes = {
  INPUT: "input",
  TEXTAREA: "textarea",
  CHECKBOX: "checkbox",
  SELECT: "select"
};

const ModalConstants = {
  WIDTH: 670
};

const DataGridConstants = {
  PAGE_SIZE: 20,
  MIN_PAGE_SIZE: 5
};

const GenericCodebookItemFormFields = {
  ID: "id",
  CODE: "code",
  TYPE: "type",
  VALUE: "value",
  VALID: "valid"
};
const PasswordKeys = {
  OLD_PASSWORD: "oldPassword",
  NEW_PASSWORD: "newPassword",
  CONFIRM_NEW_PASSWORD: "confirmNewPassword",
  MIN_LENGTH: 8
};

const TextAreaConstants = {
  MIN_ROWS: 3
};

const AttributeFormConstants = {
  TYPE_VALUES: {
    VARCHAR: "VARCHAR",
    NUMBER: "NUMBER",
    DATE: "DATE",
    FILE: "FILE",
    REFERENCE: "REFERENCE",
    READ_ONLY_REFERENCE: "READ-ONLY-REFERENCE",
    CLOB: "CLOB",
    DATETIME: "DATETIME"
  }
};
const FormSectionTypes = {
  FORM: "FORM",
  TABLE: "TABLE"
};
const FormStatus = {
  DRAFT: "DRAFT",
  SUBMITTED: "SUBMITTED"
};

const FormConfigurationConstants = {
  SUM: "SUM",
  SCALE: "SCALE"
};

const SecurityGroups = {
  ADMIN: "E_SENTENCE_ADMIN",
  OPERATER: "E_SENTENCE_OPERATER",
  USER: "E_SENTENCE_KORISNIK",
  SUPER_ADMIN: "E_SENTENCE_SUPER_ADMIN"
};

const AppConstants = {
  REGISTRY: "registry",
  PORTAL: "portal"
};

export { Topics };
export { Layouts };
export { RouteTypes };
export { UserPreferences };
export { HttpConstants };
export { BaseConstants as Constants };
export { Errors };
export { DateFormats };
export { EditFormItemTypes };
export { ModalConstants };
export { DataGridConstants };
export { GenericCodebookItemFormFields };
export { PasswordKeys };
export { TextAreaConstants };
export { AttributeFormConstants };
export { FormSectionTypes };
export { FormStatus };
export { FormConfigurationConstants };
export { TimeFormats };
export { SecurityGroups };
export { BooleanToIntegerConstants };
export { AppConstants };
export { DocumentTypes };
export { DocumentStatus };
export { GenericCodebookTypes };
export { VisibilityLevels };
